import { ServicesDirectoriesServiceProps } from '@services/requests/servicesService/servicesDirectoriesService/interface';
import ServicesDirectoriesService from '@services/requests/servicesService/servicesDirectoriesService/ServicesDirectoriesService';

// Фабрика сервиса директорий дополнительных услуг
export const servicesDirectoriesService: { (token?: string): ServicesDirectoriesServiceProps } = (
  token
) => new ServicesDirectoriesService(token);
